import React from 'react'
import FormX from 'sb-formx'
import actions from  'redux/actions'
import storeData from 'sb-store-data'
import { constants } from 'common/helpers'
import { required, email } from 'helpers/validation'
import { useWillMount } from 'sb-hooks'

import EmailField from 'components/_new/auth/EmailField/EmailField'
import CommonButton from 'components/_new/buttons/CommonButton/CommonButton'
import Text from 'components/_new/typography/Text/Text'
import Box from 'components/_new/layout/Box/Box'

import messages from './messages'
import s from './RemindPasswordForm.scss'


const form = new FormX({
  name: 'RemindPasswordForm',
  fields: {
    email: [ required, email ],
  },
})

const handleSubmit = (event) => {
  event.preventDefault()

  form.submit()
    .then(({ email }) => {
      actions.models.user.remindPassword(email, { withErrorModal: false })
        .then(() => {
          actions.models.modals.close(constants.modals.RemindPassword)

          actions.models.modals.open(constants.modals.Dialog, {
            buttonTitle: messages.btnClose,
            contentMessage: messages.confirmMessage,
          })
        })
    })
}

const RemindPasswordForm = ({ authEmail, onClickBackLink }) => {
  useWillMount(() => {
    if (authEmail) {
      form.setInitialValues({ email: authEmail })
    }
  })

  return (
    <form
      id="remindPasswordForm"
      className={s.remindPasswordForm}
      onSubmit={handleSubmit}
    >
      <EmailField className={s.field} field={form.fields.email} standardView />
      <Box className={s.actions} pt="36">
        <div className={s.linkBack} onClick={onClickBackLink}>
          <Text message={messages.linkBack} tag="span" />
        </div>
        <CommonButton
          className={s.resetPassword}
          type="submit"
          titleKey="resetPassword"
          color="brand"
          fullWidth
          uppercase
          weight="normal"
          size="md"
        />
      </Box>
    </form>
  )
}


export default storeData({
  authEmail: 'models.user.authEmail',
})(RemindPasswordForm)
